"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ActionsLayout = require("./actions-layout/ActionsLayout");
Object.keys(_ActionsLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionsLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ActionsLayout[key];
    }
  });
});
var _AdditionalFiltersLayout = require("./additional-filters-layout/AdditionalFiltersLayout");
Object.keys(_AdditionalFiltersLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AdditionalFiltersLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AdditionalFiltersLayout[key];
    }
  });
});
var _FiltersLayout = require("./filters-layout/FiltersLayout");
Object.keys(_FiltersLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FiltersLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FiltersLayout[key];
    }
  });
});
var _TableLayout = require("./table-layout/TableLayout");
Object.keys(_TableLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TableLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TableLayout[key];
    }
  });
});
var _FormLayout = require("./form-layout/FormLayout");
Object.keys(_FormLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormLayout[key];
    }
  });
});
var _FormPageLayout = require("./form-page-layout/FormPageLayout");
Object.keys(_FormPageLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormPageLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormPageLayout[key];
    }
  });
});
var _DetailsPageLayout = require("./details-page-layout/DetailsPageLayout");
Object.keys(_DetailsPageLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailsPageLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DetailsPageLayout[key];
    }
  });
});
var _SettingsLayout = require("./settings-layout/SettingsLayout");
Object.keys(_SettingsLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SettingsLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SettingsLayout[key];
    }
  });
});
var _ReportsLayout = require("./reports-layout/ReportsLayout");
Object.keys(_ReportsLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportsLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReportsLayout[key];
    }
  });
});
var _PayAccountLayout = require("./pay-account-layout/PayAccountLayout");
Object.keys(_PayAccountLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PayAccountLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PayAccountLayout[key];
    }
  });
});